import "./vision.css";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { Typewriter } from 'react-simple-typewriter'; 
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
const Vision = () => {
   const scrollConfig = {
        trigger: ".vision-gsap",
        start: "top 80%",
        end: "top 70%",
        scrub: 1,
      }
    useGSAP(() => {
    const tl3 = gsap.timeline();
    tl3.from(".vision-heading-gsap", {
      y: 100,
      opacity: 0,
      scrollTrigger:scrollConfig
    });
     tl3.from(".author", {
      y: -100,
      opacity: 0,
      duration: 0.7,
      scrollTrigger:scrollConfig
    });
      tl3.from(".quote", {
      x: 100,
      opacity: 0,
      duration: 0.7,
      scrollTrigger:scrollConfig
    });
      tl3.from(".quote2", {
      x: -100,
      opacity: 0,
      duration: 0.7,
      scrollTrigger:scrollConfig
    });

  });
  

  return (
    <>
      <section className=" thought-section py-5 vision-gsap ">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-8 mx-auto text-center  thought-container ">
            <div className="thought  vision-heading-gsap vision-section">
               <Typewriter
          words={[
            
            'To be a consistent leader in associated global power sector.'
          ]}
          loop={0} // 0 = infinite
          cursor
          cursorStyle='|'
          typeSpeed={50}
          deleteSpeed={30}
          delaySpeed={2000}
        />
              <div className="quote">❝</div>
              <div className="quote2">❞</div>
            </div>
            <div className="author vision-author fw-bold"> Our Vision</div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};
export default Vision;
